import React from "react";
import { useSelector } from "react-redux";
import { AppStore } from "../redux/store";
import { useIsCountryMatch } from "./useCountrySelected";

const useOptionsNav = (country?: string) => {
  const store = useSelector((store: AppStore) => store.country); // Si es posible dejar de usarla, se mantiene por retrocompabilidad
  const currentCountry = country || store.country;

  const isCountryMatch = useIsCountryMatch();

  const OptionComprar = [
    {
      name: "En Planos",
      link: `/${currentCountry}/venta/casas-y-apartamentos/proyectos`,
    },
    {
      name: "Casas",
      link: `/${currentCountry}/bienes-raices/comprar?type=house`,
    },
    {
      name: "Apartamentos",
      link: `/${currentCountry}/bienes-raices/comprar?type=apto`,
    },
    {
      name: "Terrenos",
      link: `/${currentCountry}/bienes-raices/comprar?type=land`
    }
  ];

  const OptionComprarGt = [
    {
      name: "En Planos",
      link: `/${currentCountry}/venta/casas-y-apartamentos/proyectos`,
    },
    {
      name: "Casas",
      link: `/${currentCountry}/bienes-raices/comprar?type=house`,
    },
    {
      name: "Apartamentos",
      link: `/${currentCountry}/bienes-raices/comprar?type=apto`,
    },
  ];

  const OptionPropietario = [
    {
      name: "Vender mi propiedad",
      link: `/${currentCountry}/venta/vender-casa-apartamento-con-propi`,
    },
    {
      name: "Rentar mi propiedad",
      link: `/${currentCountry}/alquiler/alquila-tu-casa-apartamento-con-propi`,
    },
  ];

  const OptionCalcula = [
    {
      name: "Calculadora de crédito hipotecario",
      link: `/${currentCountry}/venta/calculadora-credito-hipotecario`,
    },
    ...(isCountryMatch
      ? [
        {
          name: "Calculadora de renta",
          link: `/${currentCountry}/alquila-casa-apartamento-en-propi#calculadora`,
        },
      ]
      : []),
  ];


  const OptionPropi = [
    {
      name: "Ayuda",
      link: `/${currentCountry}/ayuda`,
    },
    {
      name: "¿Quienes somos?",
      link: `/${currentCountry}/quienes-somos`,
    },
    {
      name: "Refiere y gana",
      link: `/app/${currentCountry}/referidos`,
    },
    {
      name: "Blog",
      link: `https://blog.propilatam.com/`,
    },
  ];

  return {
    OptionComprar,
    OptionComprarGt,
    OptionPropietario,
    OptionCalcula,
    OptionPropi,
  };
};

export default useOptionsNav;
